'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002472 from "./presto.types$-Group-Name$$anon$72.js";
import * as $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002473 from "./presto.types$-Group-Name$$anon$73.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupName$() {
  this.c72 = null;
  this.c73 = false;
  this.c70 = null;
  this.c71 = false;
  this.c76 = null;
  this.c77 = false;
  this.c74 = null;
  this.c75 = false;
  this.c78 = null;
  this.c79 = false;
}
export { $c_Lpresto_types$GroupName$ as $c_Lpresto_types$GroupName$ };
$p = $c_Lpresto_types$GroupName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupName$;
/** @constructor */
function $h_Lpresto_types$GroupName$() {
}
export { $h_Lpresto_types$GroupName$ as $h_Lpresto_types$GroupName$ };
$h_Lpresto_types$GroupName$.prototype = $p;
$p.adA = (function() {
  if ((!this.c73)) {
    this.c72 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c73 = true;
  }
  return this.c72;
});
$p.me = (function() {
  if ((!this.c71)) {
    this.c70 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c71 = true;
  }
  return this.c70;
});
$p.csj = (function() {
  if ((!this.c77)) {
    this.c76 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c77 = true;
  }
  return this.c76;
});
$p.SV = (function() {
  if ((!this.c75)) {
    this.c74 = new $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002472.$c_Lpresto_types$GroupName$$anon$72(this);
    this.c75 = true;
  }
  return this.c74;
});
$p.cJ8 = (function() {
  if ((!this.c79)) {
    this.c78 = new $j_presto$002etypes$0024$002dGroup$002dName$0024$0024anon$002473.$c_Lpresto_types$GroupName$$anon$73(this);
    this.c79 = true;
  }
  return this.c78;
});
var $d_Lpresto_types$GroupName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupName$, "presto.types$GroupName$", ({
  a0a: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupName$ as $d_Lpresto_types$GroupName$ };
var $n_Lpresto_types$GroupName$;
function $m_Lpresto_types$GroupName$() {
  if ((!$n_Lpresto_types$GroupName$)) {
    $n_Lpresto_types$GroupName$ = new $c_Lpresto_types$GroupName$();
  }
  return $n_Lpresto_types$GroupName$;
}
export { $m_Lpresto_types$GroupName$ as $m_Lpresto_types$GroupName$ };
//# sourceMappingURL=presto.types$-Group-Name$.js.map
